var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoungeAlchol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAB619",
    d: "M9 8l.716-2.864C9.883 4.468 10.483 4 11.171 4H24.83c.688 0 1.288.468 1.455 1.136L27 8c.643 2.572.295 5.292-.974 7.62l-1.755 3.216c-1.448 2.656-1.728 5.794-.771 8.664l1.061 3.184c.175.524-.108 1.09-.632 1.265-.102.034-.209.051-.316.051H12.387c-.552 0-1-.448-1-1 0-.107.018-.214.052-.316L12.5 27.5c.957-2.87.677-6.008-.771-8.664L9.974 15.62C8.704 13.292 8.357 10.572 9 8z",
    transform: "translate(-32 -322) translate(20 312) translate(12 10)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC338",
    d: "M23.5 27.5l1.061 3.184c.175.524-.108 1.09-.632 1.265-.102.034-.209.051-.316.051H12.387c-.552 0-1-.448-1-1 0-.107.018-.214.052-.316L12.5 27.5c.055-.166.106-.332.153-.5h10.694c.047.168.098.334.153.5z",
    transform: "translate(-32 -322) translate(20 312) translate(12 10)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 8L24 8",
    transform: "translate(-32 -322) translate(20 312) translate(12 10)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungeAlchol);
export default __webpack_public_path__ + "static/media/lounge-alchol.f71564b6.svg";
export { ForwardRef as ReactComponent };